import { render, staticRenderFns } from "./PlanCardAiRequests.vue?vue&type=template&id=587f9c16&scoped=true"
import script from "./PlanCardAiRequests.vue?vue&type=script&lang=js"
export * from "./PlanCardAiRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587f9c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587f9c16')) {
      api.createRecord('587f9c16', component.options)
    } else {
      api.reload('587f9c16', component.options)
    }
    module.hot.accept("./PlanCardAiRequests.vue?vue&type=template&id=587f9c16&scoped=true", function () {
      api.rerender('587f9c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Plans/PlanCardAiRequests.vue"
export default component.exports